export default __webpack_public_path__ + "static/media/drawn-highlighted-emission-icon.0a3b6695.svg";